import React from 'react';

import classNames from 'classnames';

/**
 * The status filter. Counts are for the current scope and every filter except
 * status, so they hold still as the user moves between segments.
 */
export default function StatusSegment({ value, counts, onChange }) {
    const options = [
        { value: 'all', label: $t('All'), count: counts.all },
        { value: 'pending', label: $t('Pending'), count: counts.pending },
        { value: 'approved', label: $t('Approved'), count: counts.approved },
        { value: 'rejected', label: $t('Rejected'), count: counts.rejected },
    ];

    return (
        <div className="bc-seg" role="tablist" aria-label={$t('Status')}>
            {options.map((option) => {
                const active = option.value === value;

                return (
                    <button
                        key={option.value}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        onClick={() => onChange(option.value)}
                        className={classNames('bc-seg__item', { 'bc-seg__item--on': active })}
                    >
                        {option.label}
                        <span className="bc-seg__n">{option.count ?? 0}</span>
                    </button>
                );
            })}
        </div>
    );
}
